import React from 'react';
import ReactDOM from 'react-dom';
import store, { history } from './store';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';

import AuthenticatedRoutes from 'components/AuthenticatedRoutes/AuthenticatedRoutes.jsx';

import 'assets/scss/material-kit-pro-react.css?v=1.2.0';
import LoginPage from 'views/LoginPage/LoginPage.jsx';
import SignupPage from 'views/SignupPage/SignupPage.jsx';
import ProjectListPage from 'views/ProjectListPage/ProjectListPage.jsx';
import CreateProjectPageOld from 'views/ProjectListPage/CreateProjectPage.jsx';
import CreateProjectPage from 'views/CreateProjectPage/CreateProjectPage.jsx';
import ChangePasswordPage from 'views/ChangePasswordPage/ChangePasswordPage.jsx';
import DashboardPage from 'views/AdminPage/DashboardPage.jsx';
import SprintList from 'views/SprintPage/SprintList.jsx';
import SprintPage from 'views/AdminPage/SprintPage.jsx';
import CreditPage from 'views/CreditPage/CreditPage.jsx';
import UserList from 'views/UserList/userList.jsx';
import UserDeatils from 'views/UserDetail/UserDeatils';
import CreateUsers from 'views/CreateUsers/CreateUsers.jsx';
import UserStoryStatus from 'views/UserStoryStatus/UserStoryStatus.jsx';
import DiscountManagement from 'views/DiscountManagement/DiscountManagement';
import SprintSubmissionPage from 'views/SprintSubmissionPage/SprintSubmissionPage';
import PurchasePackage from 'views/PurchasePackages/PurchasePackages';
import MyStories from 'views/Mybid/MyStories';
import MySprints from 'views/Mybid/MySprint';
import DetailStories from 'views/Mybid/DetailStories';
import ProjectLists from 'views/ProjectLists/ProjectLists.jsx';
import ProjectPage from 'views/ProjectPage/ProjectPage';
import ProfilePage from 'views/profile';
import SetPasswordPage from 'views/set-password';
import SprintContractsPage from 'views/SprintContractsPage/SprintContractsPage';

const publicRoutes = [
  { path: '/login-page', name: 'LoginPage', component: LoginPage },

  { path: '/signup_invited', name: 'SignupPage', component: SignupPage },
  {
    path: '/set-password',
    name: 'Set password',
    component: SetPasswordPage,
  },
];

const privateRoutes = [
  { path: '/credits', name: 'CreditPage', component: CreditPage },
  { path: '/profile-page', name: 'Profile', component: ProfilePage },

  // { path: '/projects/:id/sprints', name: 'SprintList', component: SprintList },
  { path: '/user-list', name: 'UserListPage', component: UserList },

  { path: '/admin/projects', name: 'DashboardPage', component: DashboardPage },
  { path: '/admin/users', name: 'CreateUserPage', component: CreateUsers },
  {
    path: '/user-story-status',
    name: 'UserStoryStatus',
    component: UserStoryStatus,
  },
  { path: '/user-details', name: 'UserDetails', component: UserDeatils },
  {
    path: '/project/:id/sprint/status',
    name: 'SprintSubmissionPage',
    component: SprintSubmissionPage,
  },
  {
    path: '/sprints/:sprintId/contracts',
    name: 'SprintContractPage',
    component: SprintContractsPage,
  },
  {
    path: '/purchase-package',
    name: 'PurchasePackage',
    component: PurchasePackage,
  },
  { path: '/', name: 'ProjectListPage', component: ProjectListPage },
  {
    path: '/admin/dashboard/bids/projects',
    name: 'ProjectLists',
    component: ProjectLists,
  },
  {
    path: '/change-password',
    name: 'ChangePasswordPage',
    component: ChangePasswordPage,
  },
  {
    path: '/discount-management',
    name: 'DiscountManagement',
    component: DiscountManagement,
  },
  {
    path: '/mybid/projects/:id/sprints/:spirntId/stories',
    name: 'MyStories',
    component: MyStories,
  },
  {
    path: '/mybid/projects/:id/sprints/:spirntId/stories/:storyId',
    name: 'DetailStories',
    component: DetailStories,
  },
  {
    path: '/create-project',
    name: 'CreateProjectPage',
    component: CreateProjectPage,
  },
  {
    path: '/mybid/projects/:id/sprints',
    name: 'MySprints',
    component: MySprints,
  },
  {
    path: '/projects/:id',
    name: 'ProjectPage',
    component: ProjectPage,
    exact: false,
  },
];

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        {/* All public routes */}
        {publicRoutes.map((prop, key) => (
          <Route exact path={prop.path} key={key} component={prop.component} />
        ))}

        {/* All private routes */}
        <AuthenticatedRoutes>
          {privateRoutes.map((prop, key) => (
            <Route
              exact={prop.hasOwnProperty('exact') ? prop.exact : true}
              path={prop.path}
              key={key}
              component={prop.component}
            />
          ))}
        </AuthenticatedRoutes>
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
